import { render, staticRenderFns } from "./AddTemplateMailComponent.vue?vue&type=template&id=4f849e13&"
import script from "./AddTemplateMailComponent.vue?vue&type=script&lang=js&"
export * from "./AddTemplateMailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports